declare global {
    interface Window {
        TestBoxOrigin: string;
    }
}

class TestBoxSDK extends HTMLElement {
    private tbxOrigin: string = "";

    constructor() {
        super();
    }

    connectedCallback() {
        const originOverride = this.attributes["origin"]?.value;
        if (originOverride) {
            this.tbxOrigin = originOverride;
        } else {
            const domain = getDomain(window.location.origin);
            this.tbxOrigin = `https://testbox.${domain}`;
        }

        const shadow = this.attachShadow({ mode: "open" });
        const that = this;

        setTimeout(async () => {
            await that.loadFrame(shadow);
            await that.loadSDK(shadow);
            that.dispatchEvent(
                new CustomEvent("connect", {
                    detail: {},
                    bubbles: true,
                    composed: true,
                })
            );

            console.log("testbox mounted");
        });
    }

    disconnectedCallback() {
        console.log("testbox unmounted");
        // TODO: can we realistically handle this situation? what's the unmount use case?
    }

    adoptedCallback() {
        console.log("testbox adopted");
    }

    attributeChangedCallback(name: string, previous: string, next: string) {
        console.log(`testbox attribute ${name}: ${previous} -> ${next}`);
    }

    async loadFrame(root: ShadowRoot) {
        return new Promise<void>((resolve) => {
            if (document.getElementById("testbox-iframe") === null) {
                const callback = (event: MessageEvent) => {
                    if (event.data.tbxIframeConnected) {
                        window.removeEventListener("message", callback);
                        resolve();
                    }
                };

                window.addEventListener("message", callback);

                const iframe = document.createElement("iframe");
                iframe.setAttribute("id", "testbox-iframe");

                iframe.setAttribute(
                    "src",
                    `${this.tbxOrigin}/sdk-iframe.html#${window.location.origin}`
                );

                iframe.setAttribute(
                    "style",
                    "position:absolute; width:0; height:0; border:0;"
                );

                root.appendChild(iframe);
            } else {
                resolve();
            }
        });
    }

    async loadSDK(root: ShadowRoot) {
        return new Promise<void>((resolve, reject) => {
            if (window.TestBoxOrigin) {
                resolve();
            } else {
                window.TestBoxOrigin = this.tbxOrigin;

                const script = document.createElement("script");
                script.setAttribute("type", "module");
                script.setAttribute("crossorigin", "anonymous");
                script.setAttribute("src", `${this.tbxOrigin}/sdk-full.js`);
                script.addEventListener("load", () => resolve());
                script.addEventListener("error", (event) => reject(event));

                root.appendChild(script);
            }
        });
    }
}

const commonSecondLevelSuffix = new Set(["com.au", "co.uk"]);

export function getDomain(origin: string): string {
    const parts = origin.split(".");

    // match the longest suffix from list
    for (let i = 0; i < parts.length; i++) {
        const suffix = parts.slice(i).join(".");
        if (commonSecondLevelSuffix.has(suffix)) {
            return `${parts[i - 1]}.${suffix}`;
        }
    }

    // otherwise it's just last 2 segments
    return parts.slice(-2).join(".");
}

customElements.define("testbox-sdk", TestBoxSDK);
